import PropTypes from 'prop-types';
import DataField from './dataFields';

/**
 * @memberof module:react/propTypes
 * @typedef {Object} StoryItem
 * @prop {string} mosObjectId Mos object id
 * @prop {string} abstract Mos object abstract
 * @prop {string} channel Channel for this mos object
 * @prop {string} thumbnail URL for the preview thumbnail
 * @prop {number} itemId Id of the item
 */
export default PropTypes.shape({
  mosObjectId: PropTypes.string,
  abstract: PropTypes.string,
  channel: PropTypes.string,
  thumbnail: PropTypes.string,
  itemId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  dataFields: PropTypes.arrayOf(DataField)
});



// WEBPACK FOOTER //
// ./app/propTypes/storyItem.js